module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note 5 White.55ad3858.png";